import { CART_STATUS, StatusHelpers } from '../constants';

const BADGE_BY_STATUS = {
  [CART_STATUS.ACTIVE]: 'bg-primary',
  [CART_STATUS.AWAITING_PACKING]: 'bg-warning text-dark',
  [CART_STATUS.PACKED_AWAITING_PICKUP]: 'bg-success',
  [CART_STATUS.COMPLETED]: 'bg-secondary',
  [CART_STATUS.PAYMENT_FAILED]: 'bg-danger',
  [CART_STATUS.CANCELLED_BY_EMPLOYEE]: 'bg-danger',
  [CART_STATUS.PAYMENT_CANCELLED_BY_USER]: 'bg-danger',
  [CART_STATUS.ABANDONED]: 'bg-light text-dark',
};

const LABEL_OVERRIDES = {
  [CART_STATUS.ACTIVE]: 'Active Cart',
  awaiting_payment_confirmation: 'Payment Processing',
  [CART_STATUS.AWAITING_PACKING]: 'Awaiting Packing',
  [CART_STATUS.COMPLETED]: 'Order Completed',
  [CART_STATUS.PAYMENT_FAILED]: 'Payment Failed',
  [CART_STATUS.CANCELLED_BY_EMPLOYEE]: 'Order Cancelled',
  [CART_STATUS.PAYMENT_CANCELLED_BY_USER]: 'Order Cancelled',
};

/**
 * Badge label and Bootstrap class for a cart instance status.
 * @param {string} status
 * @param {{ deliveryOption?: string }} [options]
 */
export function getCartStatusBadge(status, options = {}) {
  const { deliveryOption } = options;

  if (status === CART_STATUS.PACKED_AWAITING_PICKUP) {
    if (deliveryOption === 'delivery') {
      return { statusText: 'Out for Delivery', statusBadgeClass: 'bg-info' };
    }
    return { statusText: 'Ready for Pickup', statusBadgeClass: 'bg-success' };
  }

  let statusText = LABEL_OVERRIDES[status];
  if (!statusText) {
    statusText = StatusHelpers.getDisplayText(status);
    if (statusText === status && status) {
      statusText = status
        .replace(/_/g, ' ')
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  }

  const statusBadgeClass = BADGE_BY_STATUS[status] || 'bg-light text-dark';
  return { statusText, statusBadgeClass };
}
